"use client"

import { DAYS_KEYS, MONTHS_KEYS } from "@/constants/constant"
import { t } from "@/languages/i18n"
import { useEffect, useState } from "react"

interface CurrentDateDisplayProps {
  locale: string
}

export const CurrentDateDisplay = ({ locale }: CurrentDateDisplayProps) => {
  const [formattedDate, setFormattedDate] = useState<string>("")

  useEffect(() => {
    const now = new Date()
    const day = now.getDate()
    const month = now.getMonth()
    const year = now.getFullYear()
    const dayOfWeek = now.getDay()

    const dayNameKey = DAYS_KEYS[dayOfWeek]
    const monthNameKey = MONTHS_KEYS[month]

    const dayName = t(dayNameKey)
    const monthName = t(monthNameKey)
    const formattedDay = String(day).padStart(2, "0")

    let formatted = ""
    if (locale === "en") {
      formatted = `${dayName}, ${monthName} ${formattedDay}, ${year}`
    } else if (locale === "cs") {
      formatted = `${dayName}, ${formattedDay} ${monthName} ${year}`
    } else {
      // vi
      formatted = `${dayName}, ${formattedDay} ${monthName}, ${year}`
    }

    setFormattedDate(formatted)
  }, [locale])

  return <span>{formattedDate}</span>
}
